import React from 'react';
import styled from 'styled-components';
import { Card, CardBody, CardSubhead, CardTitle } from '@spark/ui-components/components/Card';
import { formatNumero, formatPercentual } from '../utils/formatters';

const ChegadasForaJanelaCard = ({
  data,
  loading
}) => (
  <Card>
    <CardBody>
      <CardTitle>Chegadas fora da janela</CardTitle>
      <CardSubhead>Cargas que chegaram fora da janela de descarga da loja</CardSubhead>

      <ValueArea>
        {loading ? (
          <EmptyState>Carregando metricas...</EmptyState>
        ) : !data ? (
          <EmptyState>Nenhuma metrica encontrada.</EmptyState>
        ) : (
          <>
            <BigValue data-testid="chegadas-fora-janela-valor">{formatNumero(data.foraJanela)}</BigValue>
            <ValueCaption>
              {formatPercentual(data.percentual)} de {formatNumero(data.total)} chegadas
            </ValueCaption>
          </>
        )}
      </ValueArea>
    </CardBody>
  </Card>
);

const ValueArea = styled.div`
  min-height: 270px;
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const BigValue = styled.div`
  color: #e53935;
  font-size: 48px;
  font-weight: 700;
  line-height: 1;
`;

const ValueCaption = styled.div`
  margin-top: 12px;
  color: #4b5563;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
`;

const EmptyState = styled.div`
  width: 100%;
  height: 270px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  background: #f8f9fa;
  border: 1px dashed #d8dde3;
`;

export default ChegadasForaJanelaCard;
